import React from 'react';
import PropTypes from 'prop-types';

React.PropTypes = PropTypes;
